import React, { useState } from 'react'
import {Radio, RadioProps} from 'antd'
import {InputLabelProps} from '../common/InputLabel'
import {sharedStyles} from '../../style/shared_styles'
import {ErrorField, InputLabel} from '../common/index'
import {ErrorFieldProps} from '../common/ErrorField'
import {useDefaultValueSet} from '../common/utils/useDefaultValueSet'
import {i18n} from '../../i18n'

type RadioOption = {
    name: string
    value: any
}

const MandatoryRadioGroup: React.FC<MandatoryRadioGroupProps> = (props: MandatoryRadioGroupProps) => {
     // need to do this because cannot pass custom attributes to html <input/> tag
    const {onValueChanged, label, mandatory, extraInfo, options} = props
    useDefaultValueSet(props.value, onValueChanged, props.skipInitialize)

     const [selected, setSelected] = useState<any>(props.value)
    const inputLabelProps: InputLabelProps = {label, mandatory, extraInfo}

    return (
        <div style={sharedStyles.column}>
            <InputLabel {...inputLabelProps} />
            <Radio.Group
                onChange={e => {
                    setSelected(e.target.value)
                    onValueChanged(e.target.value)
                }}
                value={selected}
                style={{display: 'flex', flexDirection: 'column'}}>
                  {options.map(option => (
                    <Radio key={option.value} value={option.value}>
                        {option.name}
                    </Radio>
                ))}
            </Radio.Group>
            <ErrorField error={props.error ? i18n.t('userDataTab.allergyinfo.selectOption') : undefined} />
        </div>
    )
}

interface MandatoryRadioGroupProps extends RadioProps, InputLabelProps, ErrorFieldProps {
    onValueChanged: (val: any, error?: string) => void
    options: RadioOption[]
}

export default MandatoryRadioGroup
